import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import ScrollFloat from "../component/ScrollFloat";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function AiDevelopment() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleItem = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const splitTextToSpans = (text, className = "") =>
        [...text].map((char, index) => (
            <span className={`char ${className}`} key={`${char}-${index}`}>
                {char === " " ? "\u00A0" : char}
            </span>
        ));

    // light dark change image

    const [theme, setTheme] = useState("light");

    useEffect(() => {
        const currentTheme =
            document.documentElement.getAttribute("data-theme") || "light";
        setTheme(currentTheme);

        const observer = new MutationObserver(() => {
            const newTheme =
                document.documentElement.getAttribute("data-theme") || "light";
            setTheme(newTheme);
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["data-theme"],
        });

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <Helmet>
                <title>AI Development Services | Custom AI Solutions by Blockcryp</title>
                <meta
                    name="description"
                    content="Unlock business growth with Blockcryp’s AI development services—custom AI solutions, machine learning, NLP, and computer vision tailored to your needs."
                />
                <meta
                    name="keywords"
                    content=" AI development services, custom AI solutions, machine learning development, artificial intelligence company, AI software development, natural language processing (NLP), computer vision development, AI consulting services, deep learning solutions, AI integration for business"
                />
            </Helmet>
            {/* ---------- hero section start ---------- */}
            <section className="space80">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h1
                                className="heading_h1 fw-semibold"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                Trusted Generative <span className="text-primary"> AI Development </span>
                            </motion.h1>
                            <motion.p
                                className="pera_txt"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                We build advanced GenAI solutions that automate workflows and enhance productivity for modern businesses.
                            </motion.p>

                            <button class="button theme_btn mt-lg-4 mt-0" type="submit">
                                View Live Demo
                            </button>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/aidevelopment/ai_hero.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/aidevelopment/ai_hero.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Automation section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center justify-content-between g-4">
                        <div className="col-lg-5">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/aidevelopment/automation1.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/aidevelopment/automation1.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <motion.h3
                                    className="heading_h3 fw-semibold"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >AI Agent Development- Addressing Operational Inefficiencies with Automation</motion.h3>
                                <motion.p
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Traditional business models often struggle with inefficiencies, slow decision-making, high operational costs, and the inability to scale customer interactions effectively. The demand for an improved system has led businesses to rely on AI agents—autonomous intelligent problem-solver systems that perform specific tasks without human intervention.</motion.p>
                                <motion.p
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >As a leading AI agent development company, Blockcryp specializes in integrating and cloning self-learning AI agents that can automate tasks, handle customer inquiries 24/7, detect security threats, analyze customer behavior, and scale business operations efficiently.</motion.p>
                                <motion.p
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Backed by 700+ AI engineers proficient in machine learning, natural language processing,  and AI integration & deployment, we create AI-driven solutions that transform businesses into future-ready enterprises.</motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- AI Development Services  section start ---------- */}
            <section className="services space60">
                <div className="container">
                    <div className="row justify-content-center mb-4 mb-lg-5">
                        <div className="col-8">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold text-center"
                            >
                                <>
                                    {splitTextToSpans(" Our Leading-Edge Generative")}
                                    {splitTextToSpans(" AI", "text-primary")} <br className="d-md-block d-none" />
                                    {splitTextToSpans(" Development Services", "text-primary")}
                                </>
                            </ScrollFloat>
                            {/* <h3 className="heading_h3 fw-semibold">Our Leading-Edge Generative AI Development Services</h3> */}
                            <motion.p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >From custom model development to seamless integration, Blockcryp offers a comprehensive suite of generative AI development services to empower businesses to unlock the transformative potential of generative AI.</motion.p>
                        </div>
                    </div>
                    <div className="row justify-content-center g-4">
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/aidevelopment/ser1-dark.svg"
                                            : "assets/images/aidevelopment/ser1-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold">Custom Generative AI Model Development</h5>
                                <p>Our team specializes in creating bespoke generative AI models tailored to your business requirements ranging from text & code generation to image & video manipulation based on your unique data sets.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/aidevelopment/ser2-dark.svg"
                                            : "assets/images/aidevelopment/ser2-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold">Generative AI Consultation</h5>
                                <p>Being a renowned generative AI development company, Aniter guides organizations in strategically implementing generative AI. We assist businesses in identifying opportunities for automation, content creation, and data enhancement to drive efficiency.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/aidevelopment/ser3-dark.svg"
                                            : "assets/images/aidevelopment/ser3-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Advanced Generative AI Model Replication</h5>
                                <p className="mb-0">
                                    Our multidisciplinary team provides GenAI model replication services to help you replicate the success of top generative AI models such as Gemini, ChatGPT, LLaMA, PaLM, Claude, Mistral, and many more.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/aidevelopment/ser4-dark.svg"
                                            : "assets/images/aidevelopment/ser4-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Generative AI Model Fine Tuning</h5>
                                <p className="mb-0">
                                    At Blockcryp, our AI model fine-tuning service enhances previously-trained models to adapt to evolving or domain-specific needs and datasets. By making precise adjustments, we improve decision-making capabilities and prediction accuracy significantly.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/aidevelopment/ser5-dark.svg"
                                            : "assets/images/aidevelopment/ser5-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Generative AI Model Integration</h5>
                                <p className="mb-0">
                                    We excel at integrating generative AI solutions seamlessly into your existing workflows and infrastructure. Our experts ensure smooth integration while minimizing disruption and optimizing deployment for a quick and secure path to AI-powered efficiency.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/aidevelopment/ser6-dark.svg"
                                            : "assets/images/aidevelopment/ser6-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Ongoing Support & Maintenance</h5>
                                <p className="mb-0">
                                    We provide continuous support and maintenance to ensure that your generative AI solutions remain up-to-date and effective. Our team is dedicated to monitoring performance and implementing necessary updates to keep your systems running smoothly.
                                </p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- AI Development Services  section start ---------- */}
            <section className="why_choose_defi space60">
                <div className="container">
                    <div className="row mb-4 mb-lg-5">
                        <div className="col-12">
                            <div>
                                <ScrollFloat
                                    animationDuration={1}
                                    ease="back.inOut(2)"
                                    scrollStart="center bottom+=50%"
                                    scrollEnd="bottom bottom-=40%"
                                    stagger={0.09}
                                    textClassName="heading_h3 fw-semibold text-center"
                                >
                                    How can Businesses Leverage the <br className="d-md-block d-none" /> AI Agents We Create?
                                </ScrollFloat>
                                <motion.p
                                    className="text-center"
                                    initial={{ opacity: 0, y: 50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Our finely tuned AI agents are the business’s most intelligent assets, which can propel the venture forward in a myriad of ways.</motion.p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-between">
                        <div className="col-xl-5 col-lg-6">
                            <div>
                                <motion.p
                                    initial={{ opacity: 0, y: 50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                ><i className="fa-solid fa-circle-check pe-2"></i><b>Automating Repetitive Processes : </b>Our AI agents handle time-consuming tasks such as data entry, invoice processing, scheduling, and document processing with precision and speed. This improves overall productivity and frees up human resources for strategic initiatives.</motion.p>
                                <motion.p
                                    initial={{ opacity: 0, y: 50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                ><i className="fa-solid fa-circle-check pe-2"></i><b>Improving Customer Service : </b> With our specialist-built AI-enabled chatbots and virtual assistants, businesses can provide instant, 24/7 support, resolve queries faster, and deliver personalized customer experiences to boost satisfaction and retention.</motion.p>
                                <motion.p
                                    initial={{ opacity: 0, y: 50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                ><i className="fa-solid fa-circle-check pe-2"></i><b>Optimizing Business Operations : </b> We provide AI agent solutions that analyze workflows, predict demand, and automate routine tasks, enabling businesses to operate more efficiently. With AI-driven automation, companies can cut operational costs to a great extent.</motion.p>
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-6">
                            <motion.p
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            ><i className="fa-solid fa-circle-check pe-2"></i><b>Supporting Decision-Making : </b> A Block Propagation Protocol Solana’s block propagation protocol breaks down the data into smaller packets so that it can be transmitted conveniently to the Blockchain nodes. Turbine not only makes it easier for Solana to address the bandwidth issues but also enhances the transaction processing speed.</motion.p>
                            <motion.p
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            ><i className="fa-solid fa-circle-check pe-2"></i><b>Driving Sales & Marketing : </b> Our AI agents analyze customer behavior, segment audiences, and predict buying patterns in real-time, which helps businesses personalize campaigns and optimize ad placements accordingly for maximum ROI and brand impact.</motion.p>
                            <motion.p
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            ><i class="fa-solid fa-circle-check pe-2"></i><b>Enhancing Security and Compliance : </b> Our AI agent development solutions ensure regulatory compliance, continuously monitor transactions and detect anomalies. These platforms can adapt to emerging threats to protect business operations with proactive risk management.</motion.p>
                        </div>
                    </div>
                </div>
            </section >
            {/* ---------- AI Development Process  section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-10 mb-4 mb-lg-5">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold text-center"
                            >
                                <>
                                    {splitTextToSpans(" Our Strategic Generative ")}
                                    {splitTextToSpans("AI", "text-primary")} <br className="d-md-block d-none" />
                                    {splitTextToSpans(" Development Process", "text-primary")}
                                </>
                            </ScrollFloat>
                            {/* <h3 className="heading_h3 fw-semibold">Our Strategic Generative AI Development Process</h3> */}
                            <motion.p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Our rigorous generative AI development process empowers businesses with robust GenAI solutions that nurture innovation and <br className="d-md-block d-none" /> operational efficiency.</motion.p>
                        </div>
                        <div className="col-12">
                            <motion.div
                                className="ai_process"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/aidevelopment/phase-dark.svg"
                                            : "assets/images/aidevelopment/phase-light.svg"
                                    }
                                    alt="Logo"
                                    className="w-100"
                                />
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- faq section start ---------- */}
            <section className="space40">
                <div className="container">
                    <h2 className="heading_h3 fw-bold mb-4">Frequently Asked Questions</h2>
                    <div className="row">
                        <div className="col-12">
                            <div className="accordion">
                                <div className={`accordion__item ${activeIndex === 0 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(0)}>
                                        <span className="text_20 pe-4">
                                            1. What is Generative AI?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Generative AI refers to a subset of artificial intelligence that creates new content, such as text, images, or music, by learning from existing data. It leverages algorithms and models to generate outputs that mimic human-like creativity.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 1 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(1)}>
                                        <span className="text_20 pe-4">
                                            2.  What is the cost of developing a robust Generative AI solution?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            The cost of developing a generative AI solution varies based on project complexity, scope, and specific business requirements. For a precise estimate, a detailed consultation is recommended by Blockcryp’s top generative AI experts.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 2 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(2)}>
                                        <span className="text_20 pe-4">
                                            3.  How long does it take to create a generative AI solution?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            The timeline for creating a generative AI solution typically ranges from a few weeks to several months, depending on the project's complexity, data availability, and specific customization needs.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 3 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(3)}>
                                        <span className="text_20 pe-4">
                                            4.  What are the benefits of utilizing generative AI solutions?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Generative AI solutions automate tasks, create content at scale, personalize experiences, and fuel data-driven decisions. This translates to faster innovation, reduced costs, and a happy customer base.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 4 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 " onClick={() => toggleItem(4)}>
                                        <span className="text_20 pe-4">
                                            5.  What are the benefits of utilizing generative AI solutions?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Blockcryp’s generative AI integration process involves initial consultation, strategic planning, model development, seamless deployment, and ongoing support to ensure optimal performance and continuous improvement.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
